import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
/**
* @public
*/
const EllipsisVerticalIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsxs("svg", {
		"data-sanity-icon": "ellipsis-vertical",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M14 6.5C14 7.32843 13.3284 8 12.5 8C11.6716 8 11 7.32843 11 6.5C11 5.67157 11.6716 5 12.5 5C13.3284 5 14 5.67157 14 6.5Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M14 12.5C14 13.3284 13.3284 14 12.5 14C11.6716 14 11 13.3284 11 12.5C11 11.6716 11.6716 11 12.5 11C13.3284 11 14 11.6716 14 12.5Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M14 18.5C14 19.3284 13.3284 20 12.5 20C11.6716 20 11 19.3284 11 18.5C11 17.6716 11.6716 17 12.5 17C13.3284 17 14 17.6716 14 18.5Z",
				fill: "currentColor"
			})
		]
	});
});
export { EllipsisVerticalIcon, EllipsisVerticalIcon as default };

//# sourceMappingURL=EllipsisVertical.js.map